export const setAppOpacityAction = (opacity: number) => {
    if (!window.electronApi) {
        return;
    }

    window.electronApi.setOpacity(opacity);
};
